// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"6d8d048c","513":"f770e618","787":"048a42a4"}[chunkId] + ".chunk.js";
};